const config = require("./localConfig.js");

var socketIOClient = require("socket.io-client");
var sailsIOClient = require("sails.io.js");

var io = sailsIOClient(socketIOClient);

function resolveSocketUrl() {
  var hostname = window.location.hostname;
  if (hostname.endsWith(".app.github.dev")) {
    // Codespaces forwards each port as "<name>-<port>.app.github.dev";
    // swap this page's port suffix for the Sails API's (1337)
    var codespaceHost = hostname.replace(/-\d+\.app\.github\.dev$/, "-1337.app.github.dev");
    return window.location.protocol + "//" + codespaceHost;
  }
  return config.socketURL + ":" + config.port;
}

io.sails.url = resolveSocketUrl();
// Try to reconnect after a loss to the server
io.sails.reconnection = true;
//io.sails.useCORSRouteToGetCookie = true;

export default io;
